import React from "react";
import ReactDOM from "react-dom";
import ImageUploader from "react-images-upload";




class ImageUploaderComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = { pictures: [] };
    this.onDrop = this.onDrop.bind(this);
  }

  onDrop(pictureFiles, pictureDataURLs) {
    console.log("hellofsdfasdgash:" , pictureFiles);
    this.setState({
      pictures: this.state.pictures.concat(pictureFiles)
    });
  }

  render() {
    return (
      <div className="App">
        {/* <h1>React Images Upload Demo</h1> */}
        <div
          style={{
            display: "flex",
            border: "1px solid red"
          }}
        >
          <div style={{ marginRight: "15px" }}>
            <ImageUploader
              withIcon={false}
              withPreview={true}
              label=""
              // buttonText="Upload Images"
              onChange={this.onDrop}
              imgExtension={[".jpg", ".gif", ".png", ".gif", ".svg"]}
              maxFileSize={5300000}
              fileSizeError=" file size is too big"
            />
          </div>
       
          </div> 
          
      </div>
    );
  
        }
      }

        

export  default ImageUploaderComponent;
